const config = {
  baseUrl: 'https://api.dimorder.com',
};

export default config;
